import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/footer";
import MainPage from "./components/mainpage";
import ClientsPage from "./components/pages/ClientsPage";
import AboutsPage from "./components/pages/aboutsPage";
import ContactPage from "./components/pages/contactPage";
import DetailPage from "./components/detailPage";
import Products from "./components/products";
import Icons from "./components/icons";
import { useEffect, useState } from "react";
import Search from "./components/search";
import Assistant from "./components/assistant"
import Certificates from "./components/certificates";
const App = () => {
  const [searchValue, setSearchValue] = useState();

  return (
    <>
      
      <Router>
        <Header setSearchValue={setSearchValue} />
        <Search searchValue={searchValue} />
        <Assistant/>
       
        <Icons />

        <Routes>
          <Route path="/" element={<MainPage searchValue={searchValue} />} />
          <Route path="/abouts" element={<AboutsPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/products" element={<Products />} />
          <Route path="/detailpage/:id" element={<DetailPage />} />
        <Route path="/certificates" element={<Certificates/>}/>
        </Routes>
        <Footer />
      </Router>
    </>
  );
};

export default App;
